import {gql} from '@apollo/client'
import {useMemo} from 'react'
import {getCustomUserFields} from '../selectors/customers'
import {useUseCustomProfileFieldsQuery} from './generated/use-custom-profile-fields'

export const useCustomProfileFields = (environmentId: string) => {
  const query = useUseCustomProfileFieldsQuery({variables: {environmentId}})
  const customFields = useMemo(
    () => getCustomUserFields(query?.data?.environment?.preferences),
    [query?.data?.environment?.preferences]
  )

  return [customFields, {loading: query.loading, error: query.error}] as const
}

gql`
  query UseCustomProfileFields($environmentId: String!) {
    environment(id: $environmentId) {
      preferences
    }
  }
`
